import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function deleteBlogPost(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/posts/${options.id}`;
    return _fetch(url, { withAuth: true }, { method: 'DELETE' })(context);
  };
}
